<script setup>
import { openSupport } from '@/composables/useSupport'

/**
 * This was a `mailto:` to management. It assumed a configured desktop mail
 * client, did nothing on a phone, and the message never reached anywhere the
 * team could see it. The support form does both — see `useSupport`.
 */
</script>

<template>
  <section id="help-section" class="surface-card p-6">
    <div class="mb-4 flex items-center gap-3">
      <span class="material-symbols-outlined text-xl text-brand">help</span>
      <h4 class="font-bold text-ink">Need help?</h4>
    </div>
    <p class="mb-4 text-sm text-muted">Our support team is here to help you set up your teaching profile.</p>
    <button
      type="button"
      class="flex w-full items-center justify-center gap-2 rounded-lg bg-surface-2 py-3 font-medium text-ink transition-colors hover:bg-brand-soft hover:text-brand-soft-text"
      @click="openSupport()"
    >
      <span class="material-symbols-outlined">forum</span>
      Message support
    </button>
  </section>
</template>
